import { render, staticRenderFns } from "./InboundRoute.vue?vue&type=template&id=eb76230e&"
import script from "./InboundRoute.vue?vue&type=script&lang=js&"
export * from "./InboundRoute.vue?vue&type=script&lang=js&"
import style0 from "./InboundRoute.vue?vue&type=style&index=0&id=eb76230e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports